<div class="container">
  <div class="me-landing-page-faq">
    <div *ngIf="data.headline" class="me-landing-page-faq--header">
      {{data.headline}}
    </div>
    <div class="me-landing-page-faq--body">
      <div tabindex="0" role="button" [attr.aria-controls]="'accordian-body-' + question._uid" [attr.aria-expanded]="expands[question._uid]" [attr.aria-labelledby]="'accordion-' + question._uid" class="accordion-group" [class.active]="expands[question._uid]" *ngFor="let question of data.questions" (click)="toggleCollapse(question)" (keyup.enter)="toggleCollapse(question)">
          <div class="accordion-group--header">
            <span id="accordion-{{question._uid}}">{{question.question}}</span>
            <span class="accordion-group--header--icon">
              <i class="far fa-chevron-right" *ngIf="!expands[question._uid]"></i>
              <i class="far fa-chevron-down" *ngIf="expands[question._uid]"></i>
            </span>
          </div>
          <div [attr.tabindex]="expands[question._uid] ? 0 : -1" role="region" id="accordian-body-{{question._uid}}" class="accordion-group--body">
            <div [@collapse]="!expands[question._uid]" [innerHTML]="question.answer | storyblokRichtext"></div>
          </div>
      </div>
    </div>
  </div>
</div>
